module.exports = __webpack_public_path__ + "img/1-5.a007b753.svg";